<div class="tooltip-admin-toolbar" [hidden]="!isPanelVisible">

  <!-- ── Header ── -->
  <div class="toolbar-header">
    <h4 class="toolbar-title">Tooltip Admin</h4>
    <button class="btn-close-toolbar" (click)="isPanelVisible = false" title="Close">
      <i class="icon-close"></i>
    </button>
  </div>

  <!-- ── Picking state ── -->
  @if (isPickingElement) {
    <div class="picking-state">
      <div class="picking-icon">
        <i class="icon-click"></i>
      </div>
      <p class="picking-step">
        {{ pickingField === 'container' ? 'Pick Container' : 'Pick Icon Element' }}
      </p>
      <p class="picking-desc">
        @if (pickingField === 'container') {
          Click the element that should be highlighted when the tooltip opens
        }
        @if (pickingField === 'icon') {
          Click the container where the icon should be placed
        }
      </p>
      @if (pickWarning) {
        <p class="picking-warning">{{ pickWarning }}</p>
      }
      @if (pickInfo) {
        <p class="picking-info">{{ pickInfo }}</p>
      }
      <button class="btn-back" (click)="stopPicking()">Back</button>
    </div>
  }

  <!-- ── Body (scrollable) ── -->
  @if (!isPickingElement) {
    <div class="toolbar-body">
      @if (!currentEditingTooltip) {
        <div class="toolbar-section">
          <button
            class="btn btn-create-tooltip"
            (click)="startCreatingNew()">
            Create a new tooltip
          </button>
        </div>
      }
      @if (currentEditingTooltip) {
        <div class="toolbar-section">
          <div class="editing-title">
            <span>{{ isPendingNew ? 'Create Tooltip' : 'Edit Tooltip' }}</span>
          </div>
          <div class="editing-form">
            <div class="form-group">
              <label>Icon Element</label>
              <div class="element-pick-row">
                <span class="element-pick-value" [title]="currentEditingTooltip.anchor?.legacyScopedSelector ?? ''">
                  {{ currentEditingTooltip.anchor?.legacyScopedSelector ?? currentEditingTooltip.anchor?.tagName ?? 'Not selected' }}
                </span>
                <button class="btn-repick" (click)="startPickingField('icon')" title="Pick icon element">
                  <i class="icon-refresh"></i>
                </button>
              </div>
            </div>
            <div class="form-group">
              <label>Container</label>
              <div class="element-pick-row">
                <span class="element-pick-value" [title]="currentEditingTooltip.hoverAnchor?.legacyScopedSelector ?? ''">
                  {{ currentEditingTooltip.hoverAnchor?.legacyScopedSelector ?? currentEditingTooltip.hoverAnchor?.tagName ?? 'Not selected' }}
                </span>
                <button class="btn-repick" (click)="startPickingField('container')" title="Pick container element">
                  <i class="icon-refresh"></i>
                </button>
              </div>
            </div>
            <div class="form-group stacked">
              <label>Header <span class="char-count" [class.exceeded]="!validateHeaderLength(currentEditingTooltip.header ?? '')">{{ getHeaderCharCount() }}/{{ HEADER_MAX_LENGTH }}</span></label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="currentEditingTooltip.header"
                (ngModelChange)="updateCurrentTooltip()"
                [maxlength]="HEADER_MAX_LENGTH"
                placeholder="Header">
              @if (isHeaderBlank) {
                <span class="required fs-12">Header is required.</span>
              }
            </div>
            <div class="form-group stacked">
              <label>Text <span class="char-count" [class.exceeded]="!validateTextLength(currentEditingTooltip.text ?? '')">{{ getTextCharCount() }}/{{ TEXT_MAX_LENGTH }}</span></label>
              <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="editor" [toolbar]="textToolbar" [customMenuRef]="listMenu"></ngx-editor-menu>
                <ngx-editor
                  [editor]="editor"
                  [(ngModel)]="currentEditingTooltip.text"
                  (ngModelChange)="updateCurrentTooltip()"
                  [outputFormat]="'html'"
                placeholder="Tooltip text"></ngx-editor>
              </div>
            </div>
            <ng-template #listMenu>
              <div class="NgxEditor__Seperator"></div>
              <div class="list-type-dropdown dropdown">
                <button
                  type="button"
                  class="list-type-trigger"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  title="List type">
                  <i class="icon-list"></i>
                  <i class="icon-caret-down"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" (click)="setListType('bullet')">Bulleted list</a></li>
                  <li><a class="dropdown-item" (click)="setListType('ordered')">Numbered list</a></li>
                </ul>
              </div>
              <div class="list-type-dropdown dropdown">
                <button
                  #linkToggleBtn
                  type="button"
                  class="list-type-trigger"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  title="Insert link">
                  <i class="icon-link"></i>
                  <i class="icon-caret-down"></i>
                </button>
                <div class="dropdown-menu link-popup">
                  <div class="link-popup-field">
                    <label>URL</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      [(ngModel)]="linkForm.href"
                      placeholder="https://example.com or www.example.com"
                      autocomplete="off">
                    @if (linkForm.href && !isValidLinkUrl(linkForm.href)) {
                      <span class="link-popup-error">Must start with http://, https:// or www.</span>
                    }
                  </div>
                  <div class="link-popup-field">
                    <label>Display text <span class="link-popup-optional">(optional)</span></label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      [(ngModel)]="linkForm.text"
                      placeholder="Defaults to the URL"
                      autocomplete="off">
                  </div>
                  <button type="button" class="btn-link-insert" [disabled]="!isValidLinkUrl(linkForm.href)" (click)="insertLink(linkToggleBtn)">
                    Insert link
                  </button>
                </div>
              </div>
            </ng-template>
            <div class="form-group">
              <label>Position</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.position"
                [options]="tooltipPositionOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="onTooltipPositionChange(); updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Tooltip alignment</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.tooltipAlign"
                [options]="tooltipAlignmentOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Tooltip align target</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.tooltipAlignTarget"
                [options]="tooltipAlignTargetOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="onTooltipAlignTargetChange()">
              </app-simple-select>
            </div>
            @if ((currentEditingTooltip.tooltipAlignTarget ?? TooltipAlignTarget.Container) === TooltipAlignTarget.Container) {
              <div class="form-group">
                <label>Hide icon after opening</label>
                <label class="custom-switch">
                  <input type="checkbox" [(ngModel)]="currentEditingTooltip.hideIconAfterOpen" (ngModelChange)="updateCurrentTooltipImmediate()">
                  <span class="switch-track" [class.on]="currentEditingTooltip.hideIconAfterOpen">
                    <span class="switch-thumb" [class.on]="currentEditingTooltip.hideIconAfterOpen"></span>
                  </span>
                </label>
              </div>
            }
            <div class="form-group">
              <label>Icon placement mode</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.iconPlacementMode"
                [options]="iconModeOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Icon placement</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.iconPlacement"
                [options]="positionOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="onPlacementChange(); updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Icon alignment</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.iconAlign"
                [options]="alignmentOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Icon rotation</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.iconRotation"
                [options]="rotationOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Icon Offset Top (px)</label>
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="iconOffsetTopDisplay"
                (ngModelChange)="updateCurrentTooltip()"
                placeholder="0">
            </div>
            <div class="form-group">
              <label>Icon Offset Left (px)</label>
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="iconOffsetLeftDisplay"
                (ngModelChange)="updateCurrentTooltip()"
                placeholder="0">
            </div>
            <div class="form-group">
              <label>Icon symbol</label>
              <app-simple-select
                [(ngModel)]="currentEditingTooltip.iconLabel"
                [options]="iconLabelOptions"
                [backgroundColor]="'var(--main-black)'"
                [dropdownBorderColor]="'#EBE8E0'"
                [dropdownBorderWidth]="'1px'"
                [caretColor]="'#EBE8E0'"
                [sortAlphabetically]="false"
                (selectionChange)="updateCurrentTooltipImmediate()">
              </app-simple-select>
            </div>
            <div class="form-group">
              <label>Icon size (px)</label>
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="currentEditingTooltip.iconSize"
                (ngModelChange)="updateCurrentTooltip()"
                placeholder="22"
                min="8"
                max="80">
            </div>
            <div class="form-group">
              <label>Show container border</label>
              <label class="custom-switch">
                <input type="checkbox" [(ngModel)]="currentEditingTooltip.showContainerBorder" (ngModelChange)="updateCurrentTooltipImmediate()">
                <span class="switch-track" [class.on]="currentEditingTooltip.showContainerBorder">
                  <span class="switch-thumb" [class.on]="currentEditingTooltip.showContainerBorder"></span>
                </span>
              </label>
            </div>
            @if (currentEditingTooltip.showContainerBorder) {
              <div class="form-group">
                <label>Border thickness (px)</label>
                <input
                  #borderWidthInput
                  type="number"
                  class="form-control form-control-sm"
                  [(ngModel)]="currentEditingTooltip.containerBorderWidth"
                  (ngModelChange)="onBorderWidthChange(borderWidthInput)"
                  (blur)="onBorderWidthBlur(borderWidthInput)"
                  [placeholder]="BORDER_WIDTH_MIN"
                  [min]="BORDER_WIDTH_MIN"
                  [max]="BORDER_WIDTH_MAX"
                  step="1">
              </div>
              <div class="form-group">
                <label>Border color</label>
                <input
                  type="color"
                  class="form-control form-control-sm form-control-color"
                  [(ngModel)]="currentEditingTooltip.containerBorderColor"
                  (ngModelChange)="updateCurrentTooltipImmediate()">
              </div>
            }
            <div class="form-group">
              <label>Enabled</label>
              <label class="custom-switch">
                <input type="checkbox" [(ngModel)]="currentEditingTooltip.isEnabled" (ngModelChange)="updateCurrentTooltipImmediate()">
                <span class="switch-track" [class.on]="currentEditingTooltip.isEnabled">
                  <span class="switch-thumb" [class.on]="currentEditingTooltip.isEnabled"></span>
                </span>
              </label>
            </div>
            <div class="editing-actions">
              <button class="btn-action btn-cancel" [disabled]="isSaving" (click)="clearEditing()">Cancel</button>
              <button class="btn-action btn-save" [disabled]="isSaving || isHeaderBlank" (click)="saveChanges()">Save tooltip</button>
            </div>
          </div>
        </div>
      }
      @if (!currentEditingTooltip) {
        <div class="toolbar-section">
          <div class="section-header">
            <span class="section-title">Tooltips ({{ filteredTooltips.length }}/{{ tooltips.length }})</span>
            @if (tooltips?.length) {
              <button class="btn-icon-sm" (click)="deleteTooltipsOnCurrentRoute()" title="Delete all on this page">
                <i class="icon-delete"></i>
              </button>
            }
          </div>
          <div class="search-box">
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchChange()"
              placeholder="Search tooltips...">
          </div>
          <div class="tooltip-list">
            @for (tooltip of filteredTooltips; track trackById($index, tooltip)) {
              <div data-tooltip-no-anchor class="tooltip-item">
                <div class="tooltip-item-info">
                  <strong>{{ tooltip.header }}</strong>
                  @if (tooltip.isEnabled === false || isTooltipInDom(tooltip.id)) {
                    <small>{{ tooltip.text | stripHtml }}</small>
                  }
                  @if (tooltip.isEnabled !== false && !isTooltipInDom(tooltip.id)) {
                    <span class="required fs-12">Can't display tooltip</span>
                  }
                </div>
                <div class="tooltip-item-actions">
                  <label class="custom-switch">
                    <input type="checkbox" [checked]="tooltip.isEnabled !== false"
                      (change)="tooltipService.updateTooltipEnabled(tooltip.id, $any($event.target).checked)">
                    <span class="switch-track" [class.on]="tooltip.isEnabled !== false">
                      <span class="switch-thumb" [class.on]="tooltip.isEnabled !== false"></span>
                    </span>
                  </label>
                  <button class="btn-icon" (click)="editTooltip(tooltip)" title="Edit">
                    <i class="icon-edit"></i>
                  </button>
                  <button class="btn-icon btn-delete" (click)="deleteTooltip(tooltip.id)" title="Delete">
                    <i class="icon-delete"></i>
                  </button>
                </div>
              </div>
            }
            @if (filteredTooltips.length === 0) {
              <div class="no-tooltips">
                {{ tooltips.length === 0 ? 'No tooltips on this page' : 'No tooltips match your search' }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- ── Footer ── -->
  @if (!currentEditingTooltip && !isPickingElement) {
    <div class="toolbar-footer">
      <div class="footer-actions">
        <!-- Export Button with Dropdown -->
        <div class="position-relative flex-1">
          <button
            type="button"
            class="btn btn-footer dropdown-toggle-after-none w-100"
            id="tooltipExportDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            >
            <i class="icon-download position-relative" style="top:1px;"></i>
            <span>Export</span>
            <i class="icon-caret-down position-relative ml-auto" style="top:1px;"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-export" aria-labelledby="tooltipExportDropdown">
            <li>
              <a class="dropdown-item" (click)="exportTooltips()">All Tooltips</a>
            </li>
            <li>
              <a class="dropdown-item" (click)="exportCurrentPageTooltips()">Current Page Only</a>
            </li>
          </ul>
        </div>
        <!-- Import Button with Dropdown -->
        <div class="position-relative flex-1">
          <button
            type="button"
            class="btn btn-footer dropdown-toggle-after-none w-100"
            id="tooltipImportDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            >
            <i class="icon-upload position-relative" style="top:1px;"></i>
            <span>Import</span>
            <i class="icon-caret-down position-relative ml-auto" style="top:1px;"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-import" aria-labelledby="tooltipImportDropdown">
            <li>
              <label class="dropdown-item mb-0">
                All Tooltips
                <input type="file" accept=".csv" (change)="importTooltips($event, 'all')" style="display:none">
              </label>
            </li>
            <li>
              <label class="dropdown-item mb-0">
                Current Page Only
                <input type="file" accept=".csv" (change)="importTooltips($event, 'current')" style="display:none">
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  }

</div>

<ng-template #templateDeleteConfirm>
  <div class="modal-body">
    <i class="icon-close" (click)="onDeleteCancel()"></i>
    <div class="delete-header">
      <span class="icon-delete"></span>
      <div>
        <h4 class="m-0">Delete</h4>
        <span class="confirm-description">{{ deleteModalMessage }}</span>
      </div>
    </div>
    <div class="mt-4 col-12 row">
      <div class="col-6">
        <button type="button" class="btn btn-secondary w-100" (click)="onDeleteCancel()">
          <span class="btn-text">No</span>
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-primary w-100" (click)="onDeleteConfirm()">
          <span class="btn-text">Yes</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #templateConfirmSwitch>
  <div class="modal-body">
    <i class="icon-close" (click)="onCancelSwitch()"></i>
    <div class="delete-header">
      <span class="icon-warning"></span>
      <div>
        <h4 class="m-0">Unsaved Changes</h4>
        <span class="confirm-description">You have unsaved changes. Do you want to discard them?</span>
      </div>
    </div>
    <div class="mt-4 col-12 row">
      <div class="col-6">
        <button type="button" class="btn btn-secondary w-100" (click)="onCancelSwitch()">
          <span class="btn-text">Keep Editing</span>
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-primary w-100" (click)="onConfirmSwitch()">
          <span class="btn-text">Discard</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<button
  class="btn-reopen-toolbar"
  [hidden]="isPanelVisible"
  (click)="isPanelVisible = true"
  title="Open Tooltip Admin">
  ?
</button>
